import { Link } from 'react-router-dom';
import { APP_ROUTES } from '@config/routes';
import logo from '@/assets/drahft_logo_wht.webp';

const Footer = () => {
  return (
    <footer className="bg-black font-sans text-white py-16 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-8 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Link to={APP_ROUTES.HOME} className="custom-logo-link">
                <img
                  width={160}
                  height={60}
                  src={logo}
                  className="custom-logo"
                  alt="Drahft"
                  decoding="async"
                />
              </Link>
            </div>
            <p className="text-neutral-400 leading-relaxed">All-in-one tool for wedding pros.</p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Navigation</h4>
            <ul className="space-y-2 text-neutral-400">
              <li>
                <Link
                  to={APP_ROUTES.DASHBOARD}
                  className="hover:text-white transition-colors"
                >
                  Account
                </Link>
              </li>
              <li>
                <Link
                  to={APP_ROUTES.PRICING}
                  className="hover:text-white transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link to={APP_ROUTES.ROADMAP} className="hover:text-white transition-colors">
                  Roadmap
                </Link>
              </li>
              <li>
                <Link
                  to={APP_ROUTES.CONTACT}
                  className="hover:text-white transition-colors"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Resources</h4>
            <ul className="space-y-2 text-neutral-400">
              <li>
                <Link
                  to={APP_ROUTES.CHANGELOG_PUBLIC}
                  className="hover:text-white transition-colors"
                >
                  Changelog
                </Link>
              </li>
              <li>
                <Link
                  to={APP_ROUTES.DOCUMENTATION}
                  className="hover:text-white transition-colors"
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link to={APP_ROUTES.SUPPORT} className="hover:text-white transition-colors">
                  Support
                </Link>
              </li>
              <li>
                <Link
                  to={APP_ROUTES.AFFILIATE_PROGRAM}
                  className="hover:text-white transition-colors"
                >
                  Affiliate Program
                </Link>
              </li>
              <li>
                <Link to={APP_ROUTES.COMMUNITY} className="hover:text-white transition-colors">
                  Community
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Legal</h4>
            <ul className="space-y-2 text-neutral-400">
              <li>
                <Link
                  to={APP_ROUTES.PRIVACY}
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={APP_ROUTES.TERMS} className="hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to={APP_ROUTES.REFUND_POLICY}
                  className="hover:text-white transition-colors"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to={APP_ROUTES.DISCLAIMER} className="hover:text-white transition-colors">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect Column */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Connect</h4>
            <div className="flex gap-4 mb-4">
              <a
                href="https://www.instagram.com/drahft"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 bg-neutral-900 border border-neutral-800 rounded-full flex items-center justify-center text-neutral-300 hover:text-white hover:bg-neutral-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/people/Drahft/61587199649488/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 bg-neutral-900 border border-neutral-800 rounded-full flex items-center justify-center text-neutral-300 hover:text-white hover:bg-neutral-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/vincent-ybanez/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 bg-neutral-900 border border-neutral-800 rounded-full flex items-center justify-center text-neutral-300 hover:text-white hover:bg-neutral-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect width="4" height="12" x="2" y="9" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
            </div>
            <p className="text-neutral-400 text-sm">
              Get updates on new features and industry insights
            </p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="pt-8 border-t border-neutral-900 text-center text-neutral-500 text-sm">
          <p>© {new Date().getFullYear()} Drahft AI. Built with love for the wedding industry.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
